import { Pipe, PipeTransform } from '@angular/core';
import { AssistancePluginService } from './assistance-plugin.service';

@Pipe({
  name: 'assistanceaction',
  standalone: false
})
export class AssistanceActionPipe implements PipeTransform {
  public actionOptions: any[];

  constructor(private service: AssistancePluginService) {
    this.actionOptions = this.service.getActionOptions();
  }

  transform(id: string): any {
    if (!id) return '&nbsp;';

    return this.service.getValue(parseInt(id), this.actionOptions);
  }
}
